export enum GoogleRatingStatus {
    Accepted = 0,
    None = 1,
}